






































































































import RouteTab from '@/components/RouteTab.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { EscalatedAlert, EscalatedAlertLog, Vat, Product } from '@/api';
import VatChartAdmin from '@/components/charts/vat-chart-admin.vue';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';
import StatusChangeModal from './status-change-modal.vue';
import EscalatedAlertCardHeader from './escalated-alert-card-header.vue';
import InformationRow from '@/components/display/information-row.vue';
import LinkRow from '@/components/display/information-rows/link-row.vue';
import EscalatedAlertInfoPanel from './escalated-alert-info-panel.vue';
import EscalatedAlertCardUserTab from './escalated-alert-card-users-tab.vue';

@Component({
	components: {
		RouteTab,
		LinkRow,
		TooltipButton,
		VatChartAdmin,
		InformationRow,
		StatusChangeModal,
		EscalatedAlertInfoPanel,
		EscalatedAlertCardHeader,
		EscalatedAlertCardUserTab,
	},
})
export default class EscalatedAlertCardTabs extends Vue {
	@Prop({ type: Object })
	public alert!: EscalatedAlert;

	@Prop({ type: Object })
	public vat!: Vat;

	@Prop({ type: Object })
	public product!: Product;

	@Prop({ type: Boolean })
	public loadingEscalatedAlert!: boolean;

	@Prop({ type: Array })
	public alertLogs!: EscalatedAlertLog[];

	public currentPage: number = 1;
	public perPage: number = 8;
	public fields = [
		{
			key: 'old_status',
			label: 'Old Status',
		},
		{
			key: 'new_status',
			label: 'New Status',
		},
		{
			key: 'user.name',
			label: 'User',
		},
		{
			key: 'notes',
			label: 'Notes',
		},
		{
			key: 'created_at',
			label: 'At',
		},
		{
			key: 'temperature',
			label: 'Temperature',
		},
	];

	public get totalRows(): number {
		return this.alertLogs?.length ?? 0;
	}

	public get paginationText() {
		return `${this.perPage * (this.currentPage - 1) + 1} - ${Math.min(
			this.totalRows,
			this.perPage * this.currentPage,
		)} of ${this.totalRows} faults`;
	}

	public getRowColouredLogs(arr: EscalatedAlertLog[]): any[] {
		return arr.map(log => {
			if (log.temperature == null) return log;
			if (log.temperature > 6) {
				return { ...log, temperature: log.temperature, _rowVariant: 'custom-negative' };
			}
			return { ...log, temperature: log.temperature, _rowVariant: 'custom-positive' };
		});
	}
}
